import SectionHeader from "./SectionHeader";

const STEPS = [
  {
    num: "01",
    title: "填写入群申请",
    desc: "在下方表单留下你的称呼和联系方式，说明想蹲的话题，方便管理员匹配适合你的群。",
    icon: "ri-edit-2-line",
  },
  {
    num: "02",
    title: "核对入群备注",
    desc: "管理员会快速核对你的申请与意向，避免误入不相关的话题群，过程通常很快。",
    icon: "ri-user-search-line",
  },
  {
    num: "03",
    title: "接收群邀请",
    desc: "核对通过后你会收到入群邀请，进群后先看置顶公约，几分钟就能跟上节奏。",
    icon: "ri-mail-send-line",
  },
  {
    num: "04",
    title: "开始一起蹲料",
    desc: "新瓜预告、后续进度都有人同步，聊得来就多冒泡，围观潜水也完全欢迎。",
    icon: "ri-chat-smile-3-line",
  },
];

export default function Guide() {
  return (
    <section id="join" className="scroll-mt-16 bg-background-100 py-16 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <SectionHeader
          eyebrow="入群指南"
          title="想找组织？四步直达聚集地"
          desc="不清楚去哪吃、怎么加入？按下面的步骤来，轻松找到你的同好组织，不迷路。"
        />

        <div className="relative mt-12">
          {/* connector line */}
          <div className="absolute left-8 top-4 hidden h-[calc(100%-2rem)] w-px bg-background-300 lg:left-1/2 lg:block"></div>
          <ol className="grid grid-cols-1 gap-6 lg:grid-cols-4">
            {STEPS.map((s) => (
              <li key={s.num} className="relative">
                <div className="flex h-full flex-col rounded-2xl border border-background-200 bg-background-50 p-6">
                  <div className="flex items-center justify-between">
                    <span className="flex h-11 w-11 items-center justify-center rounded-2xl bg-primary-500 text-background-50">
                      <i className={`${s.icon} text-xl`} aria-hidden="true"></i>
                    </span>
                    <span className="font-heading text-3xl font-black text-background-200">{s.num}</span>
                  </div>
                  <h3 className="mt-5 font-heading text-base font-bold text-foreground-900">{s.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">{s.desc}</p>
                </div>
              </li>
            ))}
          </ol>
        </div>

        <div className="mt-8 flex flex-col items-start justify-between gap-4 rounded-2xl border border-secondary-200 bg-secondary-100/70 px-6 py-5 sm:flex-row sm:items-center">
          <div className="flex items-start gap-3">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-secondary-500 text-background-50">
              <i className="ri-lightbulb-flash-line text-lg" aria-hidden="true"></i>
            </span>
            <div>
              <p className="text-sm font-semibold text-secondary-900">入群小提醒</p>
              <p className="mt-1 text-xs leading-relaxed text-secondary-900/80 sm:text-sm">
                群内以友好交流为前提：不信谣不传谣、尊重不同观点、隐私不过度挖掘。大家一起把瓜田守好。
              </p>
            </div>
          </div>
          <a
            href="#joinform"
            className="inline-flex shrink-0 items-center gap-2 whitespace-nowrap rounded-full bg-background-50 px-6 py-3 text-sm font-semibold text-secondary-800 transition-colors hover:bg-background-100"
          >
            填写申请表
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </a>
        </div>
      </div>
    </section>
  );
}